import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

export const isPreviousCharacterWhitespaceOrStart = (
  editor: BufferEditor,
): boolean => {
  if (!editor.selection) return false

  // getRangeBefore was removed in v42 — compose the equivalent range from the
  // point one character back to the current selection.
  const pointBefore = editor.api.before(editor.selection, { unit: 'character' })
  const range = pointBefore
    ? editor.api.range(pointBefore, editor.selection)
    : undefined
  const previousChar = editor.api.string(range, { voids: true })
  return previousChar === '' || !!previousChar.match(/\s/)
}
